import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcChevronDown = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		id: "14x14 / Directional / ic-chevron-down",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Vector 2 (Stroke)",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M1.35352 4.81412L2.76773 3.3999L7.06062 7.6928L11.3535 3.3999L12.7677 4.81412L7.06062 10.5212L1.35352 4.81412Z",
			fill: "#828599"
		})
	})]
});
const ForwardRef = forwardRef(SvgIcChevronDown);
export default ForwardRef;
